import Paper from "@mui/material/Paper";
import React from "react";
import { connect } from "react-redux";
import * as myConstClass from "../../config/messageconstant";
import {
	checkedListEmptyMsg,
	noInternetMsg,
	serverMsg,
} from "../../config/messageconstant";
import {
	mapDispatchToProps,
	mapStateToProps,
} from "./advanceOutletInvoicingRedux";
import AdvanceBillingWithOffer from "./components/AdvanceBillingWithOffer";
import AdvanceOutletInvoicingOrderSection from "./components/AdvanceOutletInvoicingOrderSection";
import AdvanceOutletInvoicingSearchPanel from "./components/AdvanceOutletInvoicingSearchPanel";
import NegativeProductListDialog from "./components/NegativeProductListDialog";
import { AdvanceOutletInvoicingJson } from "../../DynamicFormsJson/Transaction/advanceOutletInvoicing";
import { LS_IS_RATE_EDITABLE_HORECA } from "./constants/advanceOutletInvoicingConstants";
import {
	buildNegativeProductRows,
	filterTableData,
	getInitialState,
	syncMasterDataFromProps,
} from "./utils/advanceOutletInvoicingUtils";
import { submitBillConfiguration } from "./utils/billingService";
import { fetchListByBeatSelection } from "./utils/listByIdService";
import {
	fetchOrdersByOutlet,
	fetchOrdersBySalesPerson,
} from "./utils/orderFetchService";
import "./styles/advanceOutletInvoicingColorVars";
import "./styles/advanceOutletInvoicing.css";

class AdvanceOutletInvoicing extends React.Component {
	constructor(props) {
		super(props);
		this.state = getInitialState(props);
	}

	setProductStockData = (productStockData) => {
		this.setState({ productStockData });
	};

	getData = async () => {
		const {
			getBeatByUserType,
			getRateEditOrNot,
			showLoador,
			showNotification,
			getSalesExecutiveByLoginAreas,
			setOutletOrderDetail,
		} = this.props;

		if (!navigator.onLine) {
			showNotification({ msg: noInternetMsg, severity: "error" });
			return;
		}

		this.setState({ searchBy: 0 });
		setOutletOrderDetail({ row: [] });

		showLoador({ loador: true });
		const results = await Promise.all([
			getBeatByUserType(),
			getSalesExecutiveByLoginAreas(),
			getRateEditOrNot(),
		]);
		showLoador({ loador: false });

		if (results.some(({ success }) => !success)) {
			showNotification({ msg: serverMsg, severity: "error" });
		}

		const { fieldData } = this.state;
		this.setState({
			flag: localStorage.getItem("stockCalAtBill") === "1",
			fieldData: {
				...fieldData,
				flag: localStorage.getItem("showFreeQtyPercetage") === "1",
			},
			isLostOrder: localStorage.getItem("lostOrderFromBilling") === "1",
		});
	};

	async componentDidMount() {
		if (navigator.onLine) {
			await this.getData();
		} else {
			this.props.showNotification({ msg: noInternetMsg, severity: "error" });
		}
	}

	syncMasterDataFromRedux = (prevProps, nextProps) => {
		const dynamicMasterData = syncMasterDataFromProps(
			prevProps,
			nextProps,
			this.state,
		);
		if (dynamicMasterData !== this.state.dynamicMasterData) {
			this.setState({ dynamicMasterData });
		}
	};

	componentDidUpdate(prevProps) {
		if (
			prevProps.beatList !== this.props.beatList ||
			prevProps.outletList !== this.props.outletList ||
			prevProps.salesExecutive !== this.props.salesExecutive
		) {
			this.syncMasterDataFromRedux(prevProps, this.props);
		}
	}

	getListById = async (data) => {
		this.setState({
			mainData: { ...this.state.mainData, ...data },
		});

		const activeSearchBy =
			data.flag != null && data.flag !== "" ? data.flag : this.state.searchBy;

		const result = await fetchListByBeatSelection({
			data,
			searchBy: activeSearchBy,
			...this.props,
		});

		if (!result) {
			return;
		}

		const nextState = {
			mainData: { ...this.state.mainData, ...result.mainDataPatch },
		};

		if (result.searchBy != null) {
			nextState.searchBy = result.searchBy;
			nextState.formData = result.formData;
		}

		if (result.dynamicMasterDataPatch) {
			nextState.dynamicMasterData = {
				...(this.state.dynamicMasterData ?? {}),
				...result.dynamicMasterDataPatch,
			};
		}

		this.setState(nextState);
	};

	onSearchList = (data) => {
		this.setState({ fieldData: data });

		if (!navigator.onLine) {
			this.props.showNotification({ msg: noInternetMsg, severity: "error" });
			return;
		}

		if (data.flag == 0) {
			fetchOrdersByOutlet({
				outletIds: data.outletIds,
				fromDate: data.fromdate,
				toDate: data.todate,
				flag: this.state.flag,
				...this.props,
				setProductStockData: this.setProductStockData,
			});
			return;
		}

		fetchOrdersBySalesPerson({
			salesPersonIds: data.salesPersonIds,
			fromDate: data.fromdate,
			toDate: data.todate,
			flag: this.state.flag,
			...this.props,
			setProductStockData: this.setProductStockData,
		});
	};

	handleCloses = () => {
		this.setState({ showCheckRecord: !this.state.showCheckRecord });
	};

	proceedAfterValidation = () => {
		const { openProductList, isLostOrder } = this.state;

		if (!isLostOrder) {
			this.saveBillConfigtation();
			return;
		}

		this.checkProductList();
		this.setState({
			isLostOrderFlag: true,
			openProductList: !openProductList,
		});
	};

	checkListValidation = () => {
		const { outletOrderDetail, showNotification } = this.props;
		const checkedRows = outletOrderDetail.outletOrderDetail.filter(
			(row) => row.checked,
		);

		if (checkedRows.length === 0) {
			showNotification({ msg: checkedListEmptyMsg, severity: "error" });
			return;
		}

		const isRateEditable =
			localStorage.getItem(LS_IS_RATE_EDITABLE_HORECA) == 1;
		if (
			isRateEditable &&
			checkedRows.some((orderData) => orderData.isRateWiseError)
		) {
			showNotification({ msg: "Invalid rate", severity: "error" });
			return;
		}

		this.proceedAfterValidation();
	};

	saveBillConfigtation = () => {
		const { showNotification, showLoador, outletOrderDetail } = this.props;
		const {
			flag,
			productStockData,
			billDate,
			billDiscountPercentage,
		} = this.state;

		this.setState({
			showCheckRecord: false,
		});

		submitBillConfiguration({
			outletOrderDetail: outletOrderDetail.outletOrderDetail,
			flag,
			productStockData,
			billDate,
			billDiscountPercentage,
			warningText: myConstClass.closedOrderWarning,
			showLoador,
			showNotification,
			onSwalConfirm: () => {
				this.setState({ openProductList: false });
			},
			onSuccess: (offerBillData) => {
				this.setState({ billwithOffer: true, offerBillData });
			},
		});
	};

	onCancel = () => {
		this.props.showLoador({ loador: false });
		this.setState({
			billwithOffer: false,
			showCheckRecord: false,
			offerBillData: [],
		});
	};

	getSelectedList = (selection) => {
		this.setState({ selection });
		const rowList = this.props.outletOrderDetail.outletOrderDetail.map(
			(rowData) => ({
				...rowData,
				checked: selection.includes(rowData.id),
			}),
		);
		this.props.setOutletOrderDetail({ row: rowList });
	};

	outletOrderDetails = ({ row }) => {
		this.props.setOutletOrderDetail({ row });
	};

	onSearch = (searchValue) => {
		this.setState({ searchValue });
	};

	checkProductList = () => {
		this.openProductListHandler(
			buildNegativeProductRows(this.props.outletOrderDetail.outletOrderDetail),
		);
	};

	openProductListHandler = (row) => {
		this.setState((prevState) => ({
			isLostOrderFlag: false,
			openProductList: !prevState.openProductList,
			stockProductData: row,
		}));
	};

	renderMainContent = () => {
		const {
			dynamicMasterData,
			selection,
			flag,
			formData,
			searchBy,
			fieldData,
		} = this.state;
		const { outletOrderDetail, stockHolderAndProductConfiguration } =
			this.props;
		const orderRows = outletOrderDetail.outletOrderDetail;
		const filteredOrderRows = filterTableData(
			orderRows,
			this.state.searchValue,
		);
		const searchList =
			searchBy == 0
				? AdvanceOutletInvoicingJson.fieldMeta
				: AdvanceOutletInvoicingJson.fieldMetaBySalsPerson;

		return (
			<Paper sx={{ p: 2, borderRadius: 2 }} elevation={0}>
				<AdvanceOutletInvoicingSearchPanel
					formData={formData}
					dynamicMasterData={dynamicMasterData}
					searchList={searchList}
					onGetListById={this.getListById}
					onSearch={this.onSearch}
					onSearchList={this.onSearchList}
					onGetData={this.getData}
				/>
				<AdvanceOutletInvoicingOrderSection
					flag={flag}
					fieldData={fieldData}
					selection={selection}
					outletOrderDetail={orderRows}
					stockHolderAndProductConfiguration={
						stockHolderAndProductConfiguration
					}
					dynamicMasterData={dynamicMasterData}
					filteredRows={filteredOrderRows}
					onSelectionChange={this.getSelectedList}
					onOutletOrderDetails={this.outletOrderDetails}
					onCheckProductList={this.checkProductList}
					onProceed={this.checkListValidation}
				/>
			</Paper>
		);
	};

	render() {
		const {
			billwithOffer,
			offerBillData,
			billDate,
			flag,
			openProductList,
			stockProductData,
			isLostOrder,
			isLostOrderFlag,
		} = this.state;
		const { outletOrderDetail } = this.props;
		const orderRows = outletOrderDetail.outletOrderDetail;

		return (
			<>
				{!billwithOffer && this.renderMainContent()}
				{billwithOffer && (
					<AdvanceBillingWithOffer
						offerBillData={offerBillData}
						onCancel={this.onCancel}
						billDate={billDate}
						flag={flag}
						redirect={false}
						stockProductData={stockProductData}
					/>
				)}
				{openProductList && orderRows.length !== 0 && (
					<NegativeProductListDialog
						open={openProductList}
						isLostOrder={isLostOrder}
						isLostOrderFlag={isLostOrderFlag}
						filteredStockProductData={filterTableData(
							stockProductData,
							this.state.searchValue,
						)}
						onClose={this.openProductListHandler}
						onSearch={this.onSearch}
						onSaveBill={this.saveBillConfigtation}
					/>
				)}
			</>
		);
	}
}

const areAoiStatesEqual = (nextState, prevState) =>
	nextState.outletOrderDetail === prevState.outletOrderDetail &&
	nextState.beatList === prevState.beatList &&
	nextState.outletList === prevState.outletList &&
	nextState.salesExecutive === prevState.salesExecutive &&
	nextState.stockHolderAndProductConfiguration ===
		prevState.stockHolderAndProductConfiguration &&
	nextState.areaList === prevState.areaList;

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{ areStatesEqual: areAoiStatesEqual },
)(AdvanceOutletInvoicing);
